export const environment = {
  production: false,
  'API_URL': 'https://onetimework.com',
  'CLIENT_URL': 'https://onetimework.com',
  'API_FILES_URL': 'https://onetimework.com/files/',
  'PROJECT_EMAIL': 'delinkevich123@gmail.com',
  'TELEGRAM': 'https://t.me/',
  'MAX_FILE_SIZE_BYTES': '5000000',
  'PROSTIR': 'https://prostir.gov.ua/',
  'EASYPAY': 'https://easypay.ua/',
  'MASTERCARD': 'https://www.mastercard.ua/',
  'VISA': 'https://www.visa.com.ua/',
  'WORK_START_FROM_OFFSET_MIN': '30',
  'WORK_CONSIDERED_NEW_TIME': '1',
  'COMMON_SUBSCRIPTION_DURATION_DAYS': '30',
  'TRIAL_SUBSCRIPTION_DURATION_DAYS': '7',
  'COMMON_SUBSCRIPTION_PRICE_DOLLARS': '1',
  'CONTACTS_EMAIL': 'delinkevich123@gmail.com',
  'CONTACTS_PHONE': '+380938198554',
  'GOOGLE_CLIENT_ID': '411455680034-oorfmoo5tmk1nvb99tp1jl04prqh4ufu.apps.googleusercontent.com',
  'DISABLE_RECURRENT_PAYMENTS': 'true'
};
